import React from "react";
import PropTypes from "prop-types";

import Section from "../common/Section";
import Form from "../common/Form";
import Fieldset from "../common/Fieldset";
import Row from "../common/Row";
import PlusMinButtons from "../common/PlusMinButtons";
import FieldsetSubHeader from "../common/FieldsetSubHeader";

import BereikDoelgroepForm from "./parts/BereikDoelgroepForm";
import SamenwerkingForm from "./parts/SamenwerkingForm";
import IntegraleToegankelijkheidForm from "./parts/IntegraleToegankelijkheidForm";
import InnovatieForm from "./parts/InnovatieForm";
import PlannenForm from "./parts/PlannenForm";
import BehoefteForm from "./parts/BehoefteForm";
import TotaalAantalBezoekers from "./parts/TotaalAantalBezoekers";
import TextAreaInput from "../common/TextAreaInput";

const BeoordelingscriteriaBovenlokaalForm = (props) => {
	const {
		beoordelingscriteria,
		doelgroepen,
		disabled,
		errors,
		validationMessageType,
		onChange,
		documenten,
		onChangeBereikDoelgroep,
		onAddBereikDoelgroep,
		onRemoveBereikDoelgroep,
		onDropFiles,
		onDeleteFile,
		onSave,
		color,
		onCheckboxChange,
		fileTypes,
		fileSessionStarted,
		voorbeeldInplantingsplanURL
	} = props;

	const jaNee = [{ value: "true", label: 'Ja' }, { value: "false", label: 'Nee' }];

	function getFilesForDossierComponent(component) {
		if (documenten) {
			const folder = documenten.find(x => x.name === component);
			if (folder) return folder.files;
		}
		return [];
	}

	function mapChangeBereikDoelgroep(i, isFuture) {
		return function (event) {
			onChangeBereikDoelgroep(event, i, isFuture);
		};
	}

	function mapRemoveBereikDoelgroep(i, isFuture) {
		return function (event) {
			onRemoveBereikDoelgroep(event, i, isFuture);
		};
	}

	function mapAddBereikDoelgroep(isFuture) {
		return function (event) {
			onAddBereikDoelgroep(isFuture);
		};
	}

	const aantalBezoekersVolgendeIndexes = [1, 2, 3, 4, 5];
	const aantalBezoekersVorigeIndexes = [5, 4, 3, 2, 1];

	const doelgroepenVolgende5JaarComponents = beoordelingscriteria.bereikDoelgroepenVolgende5Jaar.map((bd, i) => {
		let doelgroepErrors = null;
		if (errors != null) {
			doelgroepErrors = errors.bereikDoelgroepenVolgende5Jaar != null ? errors.bereikDoelgroepenVolgende5Jaar[i] : null;
		}
		const enablePlusButton = beoordelingscriteria.bereikDoelgroepenVolgende5Jaar.length == (i + 1);

		return (
			<Row key={"volgende" + i}>
				<BereikDoelgroepForm
					onChange={mapChangeBereikDoelgroep(i, true)}
					bereikDoelgroep={beoordelingscriteria.bereikDoelgroepenVolgende5Jaar[i]}
					doelgroepenForSelectList={doelgroepen}
					errors={doelgroepErrors}
					validationMessageType={validationMessageType}
					disabled={disabled}
					isInTheFuture
					indexes={aantalBezoekersVolgendeIndexes}
				/>

				<PlusMinButtons
					minButtonEnabled={beoordelingscriteria.bereikDoelgroepenVolgende5Jaar.length > 1}
					plusButtonEnabled={enablePlusButton}
					onMinButtonClick={mapRemoveBereikDoelgroep(i, true)}
					onPlusButtonClick={mapAddBereikDoelgroep(true)}
					disabled={disabled}
				/>
			</Row>
		);
	});

	const doelgroepenVolgende5JaarTotalComponent =
		(<TotaalAantalBezoekers indexes={aantalBezoekersVolgendeIndexes} isInTheFuture bereikDoelgroepen={beoordelingscriteria.bereikDoelgroepenVolgende5Jaar} />);

	const doelgroepenVorige5JaarComponents = beoordelingscriteria.isRenovatie ? beoordelingscriteria.bereikDoelgroepenVorige5Jaar.map((bd, i) => {
		let doelgroepErrors = null;
		if (errors != null) {
			doelgroepErrors = errors.bereikDoelgroepenVorige5Jaar != null ? errors.bereikDoelgroepenVorige5Jaar[i] : null;
		}
		const enablePlusButton = beoordelingscriteria.bereikDoelgroepenVorige5Jaar.length == (i + 1);

		return (
			<Row key={"vorige" + i}>
				<BereikDoelgroepForm
					onChange={mapChangeBereikDoelgroep(i, false)}
					bereikDoelgroep={beoordelingscriteria.bereikDoelgroepenVorige5Jaar[i]}
					doelgroepenForSelectList={doelgroepen}
					errors={doelgroepErrors}
					validationMessageType={validationMessageType}
					disabled={disabled}
					isInTheFuture={false}
					indexes={aantalBezoekersVorigeIndexes}
				/>
				<PlusMinButtons
					minButtonEnabled={beoordelingscriteria.bereikDoelgroepenVorige5Jaar.length > 1}
					plusButtonEnabled={enablePlusButton}
					onMinButtonClick={mapRemoveBereikDoelgroep(i, false)}
					onPlusButtonClick={mapAddBereikDoelgroep(false)}
					disabled={disabled}
				/>
			</Row>
		);
	}) : "";

	const doelgroepenVorige5JaarTotalComponent =
		(<TotaalAantalBezoekers indexes={aantalBezoekersVorigeIndexes} isInTheFuture={false} bereikDoelgroepen={beoordelingscriteria.bereikDoelgroepenVorige5Jaar} />);


	return (
		<Section title="Vul het antwoord op onderstaande vragen in" color={color}>
			<Form
				title={"Invulformulier beoordelingscriteria"}
				name="beoordelingscriteria"
				rightButtonLabel="Bewaar"
				onRightButtonClick={onSave}
				rightButtonDisabled={disabled}>
				<PlannenForm
					beoordelingscriteria={beoordelingscriteria}
					documenten={documenten}
					disabled={disabled}
					errors={errors}
					validationMessageType={validationMessageType}
					onChange={onChange}
					onDropFiles={onDropFiles}
					onDeleteFile={onDeleteFile}
					color={color}
					fileTypes={fileTypes}
					fileSessionStarted={fileSessionStarted}
					voorbeeldInplantingsplanURL={voorbeeldInplantingsplanURL}
				/>
				<BehoefteForm
					beoordelingscriteria={beoordelingscriteria}
					disabled={disabled}
					errors={errors}
					validationMessageType={validationMessageType}
					onChange={onChange}
				/>
				<Fieldset title="Bereik">
					<div>
						<FieldsetSubHeader>Geef een inschatting van het aantal te verwachten bezoekers over een periode van 5 jaar vanaf de opening met betrekking tot de sportinfrastructuur waarvoor subsidies wordt gevraagd.</FieldsetSubHeader>
						<br />
						<br />
						{doelgroepenVolgende5JaarComponents}
						{doelgroepenVolgende5JaarTotalComponent}
					</div>
					{doelgroepenVorige5JaarComponents ?
						<div>
							<br />
							<br />
							<FieldsetSubHeader>Geef een inschatting van het aantal bezoekers van de afgelopen 5 jaar met betrekking tot de sportinfrastructuur waarvoor subsidies wordt gevraagd.</FieldsetSubHeader>
							<br />
							<br />
							{doelgroepenVorige5JaarComponents}
							{doelgroepenVorige5JaarTotalComponent}
						</div>
						: ""}
					<Row>
						&nbsp;
						<FieldsetSubHeader>Licht bovenstaande cijfers duidelijk toe.</FieldsetSubHeader>
					</Row>
					<Row>
						&nbsp;
						<TextAreaInput
							name="toelichtingCijfersBereik"
							label="Toelichting"
							value={beoordelingscriteria.toelichtingCijfersBereik}
							onChange={onChange}
							height={4}
							disabled={disabled}
							validationMessage={errors ? errors.toelichtingCijfersBereik : ''}
							validationMessageType={validationMessageType}
							maxLength={4000} />
					</Row>

				</Fieldset>
				<SamenwerkingForm
					beoordelingscriteria={beoordelingscriteria}
					documenten={documenten}
					disabled={disabled}
					errors={errors}
					validationMessageType={validationMessageType}
					onChange={onChange}
					onDropFiles={onDropFiles}
					onDeleteFile={onDeleteFile}
					color={color}
					fileTypes={fileTypes}
					fileSessionStarted={fileSessionStarted}
				/>
				<IntegraleToegankelijkheidForm
					beoordelingscriteria={beoordelingscriteria}
					documenten={documenten}
					disabled={disabled}
					onCheckboxChange={onCheckboxChange}
					errors={errors}
					validationMessageType={validationMessageType}
					onChange={onChange}
					onDropFiles={onDropFiles}
					onDeleteFile={onDeleteFile}
					color={color}
					fileTypes={fileTypes}
					fileSessionStarted={fileSessionStarted}
				/>
				<InnovatieForm
					beoordelingscriteria={beoordelingscriteria}
					disabled={disabled}
					errors={errors}
					validationMessageType={validationMessageType}
					onChange={onChange}
				/>
			</Form>
		</Section>
	);
};

// ----------------------------------------------------------------------------
BeoordelingscriteriaBovenlokaalForm.propTypes = {
	beoordelingscriteria: PropTypes.object.isRequired,
	doelgroepen: PropTypes.array.isRequired,
	disabled: PropTypes.bool,
	errors: PropTypes.object,
	color: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	onCheckboxChange: PropTypes.func.isRequired,
	onChangeBereikDoelgroep: PropTypes.func.isRequired,
	onAddBereikDoelgroep: PropTypes.func.isRequired,
	onRemoveBereikDoelgroep: PropTypes.func.isRequired,
	onSave: PropTypes.func.isRequired,
	documenten: PropTypes.array,
	onDropFiles: PropTypes.func.isRequired,
	onDeleteFile: PropTypes.func.isRequired,
	fileTypes: PropTypes.object,
	fileSessionStarted: PropTypes.bool,
	voorbeeldInplantingsplanURL: PropTypes.string,
	validationMessageType: PropTypes.string
};

export default BeoordelingscriteriaBovenlokaalForm;
